<div 
    v-if="results.length" 
    class="results grid pagelist-grid pagelist-results grid-x grid-margin-x">
    <article
        v-for="result in results"
        class="cell pagelist-result grid-item is-link small-12 medium-6 large-4 margin-bottom-2 text-center"
        :class="result.className"
        :key="result.id"
    >
        <figure
            class="
                image-aspect-ratio
                three-by-two
                remove-bottom
            "
        >
            <img 
                v-if="result.image && result.image.listImageURL"
                loading="lazy"
                :src="result.image.listImageURL"
                alt=""
            />
            <img
                v-else
                loading="lazy"
                src="../../../../images/no-image-3x2.png"
                alt=""
            />
        </figure>
        <div class="grid-caption">
            <h3
                class="
                    h2
                    font-bold
                "
            >
                {{ result.title }}
            </h3>
            <hr />
            <p
                v-if="result.summary"
                class="result-description"
            >
                {{ result.summary }}
            </p>
            <div class="result-category-icon"></div>
        </div>
        <a :href="result.link" class="absolute-cover" v-if="result.link">
            <span class="show-for-sr">
                Read More About {{ result.title }}
            </span>
        </a>
    </article>
</div>
<div 
    v-else-if="isLoading.loading"
    class="text-center margin-top-3 margin-bottom-3"
>
    <p>
        Loading...
    </p>
</div>  
<div 
    v-else
    class="text-center margin-top-3 margin-bottom-3"
>   <p class="h4">Oops...</p>
    <p>No results found. Please try again.</p>
</div>    